import React, { useState, useEffect } from "react";
import { CreditSearchContext } from "./creditSearch";
import { createPortal } from "react-dom";
import { useLocation, useNavigate ,useParams} from "react-router-dom";
import { Navbar_1 } from "../../UiComponents";
import SidebarDD from "./SideBar/SidebarDD";
import Preview from "./Preview/Preview";
import CardPreview from "./Cards/CardPreview";
import Options from "./Options/Options";
import Footer from "./Footer/Footer";
import "./Project.css";
import "../WNewUserTutorials/PopupBoxStyle.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Components/CustomToast/CustomToast.css";
import CustomToast, { customToatStyle} from "../../Components/CustomToast/CustomToast";

import { Scrollx_animate } from "../../assets/icons";
import { getCurrentNotification } from "../utils/global";

import { useSelector, useDispatch } from "react-redux";
import { getDefalutLogos, getProjectDetails, fetchUserFonts } from "../../Redux/actions/projectActions";
import {
  getCurrentPlan,
  getNotification,
  addNotifications,
  getUserAllInformation,
} from "../../Redux/actions/commonActtion";
import {
  getApiFontUrl,
  injectFontFaceFromUrl,
} from "./Options/OptionFont/FontComponent/fontFaceUtils";
import { getRenderCnt } from "../../Redux/actions/authActions";

export default function Project() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // Derive isCard from the route so a refresh or direct link to
  // /dashboard/card/:projectId always loads the card endpoints,
  // regardless of stale localStorage / missing router state.
  const isCard = /\/dashboard\/card(\/|$)/.test(location.pathname);
  const isRenderPage = location.pathname.endsWith("/render");
  const [isRenderExport, setIsRenderExport] = useState(false);
  const { projectId } = useParams();
  const [isTitleSafe, setIsTitleSafe] = useState(true);
  const [isScrBound, setIsScrBound] = useState(false);
  const [aspectRatio_FrameSize, setAspectRatio_FrameSize] = useState("Class1x78");
  const [reLoading, setReLoading] = useState({ condn: false, label: "" });
  const [selectRatio, setSelectRatio] = useState(false);
  const [savedSaving, setSavedSaving] = useState("");
  const isRederFinished = useSelector(
    (state) => state.commonReducer.isRederFinished
  );
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [loadOnProjectFetch, setLoadOnProjectFetch] = useState(true);
  const millisecondsToWait = 1 * 60 * 1000;

  const [isDisplayTitle, setIsDisplayTitle] = useState(true);

  // Keep localStorage in sync for older code paths that still read it
  useEffect(() => {
    localStorage.setItem("isCard", JSON.stringify(Boolean(isCard)));
  }, [isCard]);

  useEffect(() => {
    // SyncProject();
    getAllDefaultLogos();
  }, []);

  const getAllDefaultLogos = async () => dispatch(getDefalutLogos());

  const SyncProject = async () => {
    const res = await dispatch(getProjectDetails(projectId, isCard));
    dispatch(getCurrentPlan());
    return res;
  };

  const fetchProjectDetails = async () => {
    setLoadOnProjectFetch(true);
    try {
      const res = await dispatch(getProjectDetails(projectId, isCard));

      // Preload and inject custom fonts so preview renders with correct typography.
      const fontsResp = await dispatch(fetchUserFonts());
      const fonts =
        fontsResp?.fonts ||
        fontsResp?.data?.fonts ||
        (Array.isArray(fontsResp) ? fontsResp : []);

      if (Array.isArray(fonts) && fonts.length) {
        fonts.forEach(({ fontFamily, proxyUrl }) => {
          injectFontFaceFromUrl(
            fontFamily,
            getApiFontUrl(proxyUrl),
          );
        });
      }

      dispatch(getCurrentPlan());
      return res;
    } catch (err) {
      alert("Something went wrong");
    } finally {
      setLoadOnProjectFetch(false);
    }
  };

  const fetchRenderCnt = () => {
     dispatch(getRenderCnt());
  }

  useEffect(() => {
    fetchProjectDetails();
    fetchRenderCnt();
  }, []);

  const customFonts = useSelector((state) => state?.project?.customFonts ?? []);

  // Keep custom uploaded fonts available as soon as the project loads.
  useEffect(() => {
    if (!customFonts?.length) return;
    customFonts.forEach(({ fontFamily, proxyUrl }) => {
      injectFontFaceFromUrl(fontFamily, getApiFontUrl(proxyUrl));
    });
  }, [customFonts]);

  const getBlockSize = (asd, val) => {
    setAspectRatio_FrameSize(val);
    switch (val) {
      case "hdClass":
        return setAspectRatio_FrameSize(val);

      case "fhdClass":
        return setAspectRatio_FrameSize(val);

      case "qhdClass":
        return setAspectRatio_FrameSize(val);

      default:
        return "deafult";
    }
  };

  

  const projectData = useSelector((state) => state.project);
  const [creditSearchQuery, setCreditSearchQuery] = useState("");
  const blocks = projectData?.credits?.map((credit) => ({
    block_name: credit?.options?.block_name,
    block_type: credit?.options?.block_type,
    _id: credit._id,
    heading: credit?.options?.heading,
    subheading: credit?.options?.subheading,
    items: credit.items,
  }));

  const currentBlockId = projectData?.currentBlock?.id;

  const currentBlockIdx = projectData?.credits?.findIndex(
    (credit) => credit._id === currentBlockId
  );

  const currentBlockOptions = ![undefined, -1].includes(currentBlockIdx)
    ? projectData?.credits[currentBlockIdx]?.options
    : {};

  const { previewWidth } = useSelector((state) => state?.application);



  // Card preview width follows the selected resolution's aspect ratio
  // (e.g. 1920x1080 -> 16:9, 1920x1440 -> 4:3). Base height 450px keeps
  // 16:9 at the previous 800px; other ratios scale from the same height.
  const CARD_PREVIEW_HEIGHT = 450;
  const cardAspectRatio =
    projectData?.resolution?.videoWidth && projectData?.resolution?.videoHeight
      ? projectData.resolution.videoWidth / projectData.resolution.videoHeight
      : 16 / 9;
  const cardPreviewWidth = `${Math.round(CARD_PREVIEW_HEIGHT * cardAspectRatio)}px`;


  async function fetchData() {
    const filtr = projectData.renders.filter((render) => {
      return (
        render !== null &&
        render !== undefined &&
        render.isRederFinished === false
      );
    });

    if (filtr?.length === 0) return;
    const res = await fetchProjectDetails();
    let result = res?.data?.project?.renders;
    const renderFinished = result?.filter((render) => {
      return (
        render !== null &&
        render !== undefined &&
        render?.isRederFinished === false
      );
    });

    if (renderFinished?.length === 0) {
      toast(
        <CustomToast
          title=""
          content={
            "Your export has been completed! Please check the render page and proceed to download."
          }
        />,
        customToatStyle
      );
      const noti = getCurrentNotification();

      const payload = {
        project_id: noti.project_id,
        render_id: noti.render_id,
        message: `Render in progress ${noti.details.videoFilename}`,
        status: 1,
        user_id: noti.user_id,
      };

      await dispatch(addNotifications(payload));
      await dispatch(getNotification({ page_no: 1, limit: 0 }));
      return;
    }
  }

  // useEffect(() => {
  //   let timer = setInterval(renderRandomCall, millisecondsToWait);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);

  useEffect(() => {
    fetchData()
    dispatch(getNotification({ page_no: 1, limit: 0 }));
  }, []);

  // Function to handle fullscreen change
  const onFullscreenChange = () => {
    setIsFullscreen(!!document.fullscreenElement);
  };
  // Effect to add and clean up fullscreen change event listeners
  useEffect(() => {
    document.addEventListener("fullscreenchange", onFullscreenChange);
    document.addEventListener("mozfullscreenchange", onFullscreenChange); // Firefox
    document.addEventListener("webkitfullscreenchange", onFullscreenChange); // Chrome, Safari, and Opera
    document.addEventListener("msfullscreenchange", onFullscreenChange); // IE/Edge
    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener("fullscreenchange", onFullscreenChange);
      document.removeEventListener("mozfullscreenchange", onFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        onFullscreenChange
      );
      document.removeEventListener("msfullscreenchange", onFullscreenChange);
    };
  }, []);

  // Function to enter fullscreen mode
  const enterFullscreen = () => {
    const previewContainer = document.getElementById("preview-container");
    if (previewContainer.requestFullscreen) {
      previewContainer.requestFullscreen();
    } else if (previewContainer.mozRequestFullScreen) {
      // Firefox
      previewContainer.mozRequestFullScreen();
    } else if (previewContainer.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      previewContainer.webkitRequestFullscreen();
    } else if (previewContainer.msRequestFullscreen) {
      // IE/Edge
      previewContainer.msRequestFullscreen();
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      // Firefox
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      // Chrome, Safari and Opera
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      // IE/Edge
      document.msExitFullscreen();
    }
  };

  const handleFooterClick = () => {
    if (isFullscreen) {
      exitFullscreen();
    } else {
      enterFullscreen();
    }
  };

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer not-italic"
      onClick={closeToast}
    >
      ✖
    </i>
  );

  return (
    <>
      <ToastContainer closeButton={CloseButton} newestOnTop />

      {/* {createPortal(
        <ToastContainer closeButton={CloseButton} newestOnTop />,
        document.body
      )} */}

      {loadOnProjectFetch && (
        <div className="modal-overlayLoader ">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80 LoadOnProjectimg"
            width="120px"
            height="120px"
          />
        </div>
      )}

      {reLoading?.condn ? (
        <div className="modal-overlayLoader">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80"
            width="120px"
            height="120px"
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Syncing...</p>
        </div>
      ) : null}

      <div className="wlcmProjectContainer">
        <div className="projectContainer">
          
          <div className="projectHead">
            <Navbar_1 />
          </div>

          <CreditSearchContext.Provider value={creditSearchQuery}>
          <div className="projectBody">
            <div className="sideNav">
              <SidebarDD
                currentBlockId={currentBlockId}
                blocks={blocks}
                projectData={projectData}
                searchQuery={creditSearchQuery}
                setSearchQuery={setCreditSearchQuery}
              />
            </div>

            <div
              className={
                "preview" + (isRenderPage ? " is-render-page-hidden" : "")
              }
              id="preview-container"
              style={{
                // backgroundColor: "#080808",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                flexGrow: 1,
                borderRadius: "0 0 10px 10px",
              }}
            >
              <div
                className={"scrollFrame " + (
                  isCard
                    ? isFullscreen
                      ? "w-full h-full"
                      : "h-[100%]  RespPreviewClass"
                    : isFullscreen
                    ? aspectRatio_FrameSize === "Class1x33"
                      ? "Class1x33Preview"
                      : aspectRatio_FrameSize === "Class2x39"
                      ? "Class2x39Preview"
                      : aspectRatio_FrameSize === "Class1x78"
                      ? "Class1x78Preview"
                      : aspectRatio_FrameSize === "Class1x85"
                      ? "Class1x85Preview"
                      : aspectRatio_FrameSize === "Class1x9"
                      ? "Class1x9Preview"
                      : aspectRatio_FrameSize === "Class2_35x1"
                      ? "Class2_35x1Preview"
                      : "w-full h-full"
                    : aspectRatio_FrameSize === "Class1x33"
                    ? "Class1x33"
                    : aspectRatio_FrameSize === "Class2x39"
                    ? "Class2x39"
                    : aspectRatio_FrameSize === "Class1x78"
                    ? "Class1x78"
                    : aspectRatio_FrameSize === "Class1x85"
                    ? "Class1x85"
                    : aspectRatio_FrameSize === "Class1x9"
                    ? "Class1x9"
                    : aspectRatio_FrameSize === "Class2_35x1"
                    ? "Class2_35x1"
                    : "h-[100%]  RespPreviewClass"
                )}
                style={{
                   width: isCard ? cardPreviewWidth : "",
                  // borderLeft: !isCard && isTitleSafe ? "2px dashed #373843" : "",
                  // borderRight: !isCard && isTitleSafe ? "2px dashed #373843" : "",
                }}
              >
                {!isCard && (
                  <Preview
                    projectData={projectData}
                    isFullscreen={isFullscreen}
                    onFullscreenToggle={handleFooterClick}
                    isRenderExport={isRenderExport}
                    setIsRenderExport={setIsRenderExport}
                     isTitleSafe={isTitleSafe}
                    aspectRatio_FrameSize={aspectRatio_FrameSize}
                  />
                )}
                {isCard && (
                  <CardPreview
                    projectData={projectData}
                    isFullscreen={isFullscreen}
                    exitFullscreen={exitFullscreen}
                    isDisplayTitle={isDisplayTitle}
                    isRenderExport={isRenderExport}
                    setIsRenderExport={setIsRenderExport}
                    blocks={blocks}
                  />
                )}
              </div>
              {/* <div className="projectFooter">
            <Footer
              setReLoading={setReLoading}
              currentBlockOptions={currentBlockOptions}
              isTitleSafe={isTitleSafe}
              setIsTitleSafe={setIsTitleSafe}
              isScrBound={isScrBound}
              setIsScrBound={setIsScrBound}
              selectRatio={selectRatio}
              setSelectRatio={setSelectRatio}
              getBlockSize={getBlockSize}
              aspectRatio_FrameSize={aspectRatio_FrameSize}
              setAspectRatio_FrameSize={setAspectRatio_FrameSize}
              handleFooterClick={handleFooterClick}
              isCard={isCard}
              isDisplayTitle={isDisplayTitle}
              setIsDisplayTitle={setIsDisplayTitle}
              isRenderExport={isRenderExport}
              setIsRenderExport={setIsRenderExport}
            />
          </div> */}
            </div>

            <div className="options">
              <Options
                currentBlockOptions={currentBlockOptions}
                currentBlockIdx={currentBlockIdx}
                currentBlockId={currentBlockId}
                setReLoading={setReLoading}
                isCard={isCard}
                setIsRenderExport={setIsRenderExport}
                aspectRatio_FrameSize={aspectRatio_FrameSize}
                setAspectRatio_FrameSize={setAspectRatio_FrameSize}
              />
            </div>
             <div className="projectFooter">
            <Footer
              setReLoading={setReLoading}
              currentBlockOptions={currentBlockOptions}
              isTitleSafe={isTitleSafe}
              setIsTitleSafe={setIsTitleSafe}
              isScrBound={isScrBound}
              setIsScrBound={setIsScrBound}
              selectRatio={selectRatio}
              setSelectRatio={setSelectRatio}
              getBlockSize={getBlockSize}
              aspectRatio_FrameSize={aspectRatio_FrameSize}
              setAspectRatio_FrameSize={setAspectRatio_FrameSize}
              handleFooterClick={handleFooterClick}
              isCard={isCard}
              isDisplayTitle={isDisplayTitle}
              setIsDisplayTitle={setIsDisplayTitle}
              isRenderExport={isRenderExport}
              setIsRenderExport={setIsRenderExport}
            />
          </div>
          </div>
          </CreditSearchContext.Provider>
        </div>

        
      </div>
    </>
  );
}
